"use client";

import { useTranslations } from "next-intl";
import { Alert, AlertDescription, AlertTitle } from "@ui/components/alert";
import { AlertCircle } from "lucide-react";

export function AnalyticsNoDataState() {
  const t = useTranslations();
  
  return (
    <Alert>
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>{t("properties.analytics.noDataAvailable")}</AlertTitle>
      <AlertDescription>
        {t("properties.analytics.noDataAvailableDescription")}
      </AlertDescription>
    </Alert>
  );
} 